// extracted by mini-css-extract-plugin
export var productImage = "_rm-1";
export var viewLink = "_rm-2";
export var wishlistItem = "_rm-0";